function optionalText(value: unknown): string | undefined {
  if (value === undefined || value === null || value === '') return undefined;
  const text = String(value).trim();
  return text || undefined;
}

export function formatAddress(value: unknown): string | undefined {
  if (!value) return undefined;
  if (typeof value === 'string') return value.trim() || undefined;
  if (typeof value !== 'object' || Array.isArray(value)) return undefined;

  const address = value as Record<string, unknown>;
  const street = optionalText(address['street'] ?? address['address1'] ?? address['line1']);
  const street2 = optionalText(address['street2'] ?? address['address2'] ?? address['line2']);
  const city = optionalText(address['city']);
  const state = optionalText(address['state']);
  const zip = optionalText(address['zip'] ?? address['postalCode']);
  const country = optionalText(address['country']);
  const stateZip = [state, zip].filter(Boolean).join(' ');
  const formatted = [
    [street, street2].filter(Boolean).join(', '),
    [city, stateZip].filter(Boolean).join(', '),
    country,
  ]
    .filter(Boolean)
    .join(', ');

  return formatted || undefined;
}
